import { render, staticRenderFns } from "./ActionTagList.vue?vue&type=template&id=5f5e1417"
import script from "./ActionTagList.vue?vue&type=script&lang=js"
export * from "./ActionTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports